import { namespaces } from '@/helpers/constants'
import historyCalls from './calls/history'
import { actions as solCallsActions, getters as solCallsGetters } from './calls/solution'

import customSolutionCalls from './calls/custom_solution'
import practiceCalls from './calls/practice'
import uploadCalls from './calls/upload'
import paymentsCalls from './calls/payments'
import settingsCalls from './calls/settings'
import gameformatsCalls from './calls/gameformats'
import shortcutsCalls from './calls/shortcuts'
import drillsCalls from './calls/drills'
import tagsCalls from './calls/tags'
import practiceTrainerCalls from './calls/practice_trainer'
import savedFilterCalls from './calls/savedFilters'
import coachingsCalls from './calls/coachings'

import { actions as clientActions, getters as clientGetters, base } from './client'

// -- /api/v1/poker/custom-solutions/batch-delete/
// -- /api/v1/poker/practice/practice-hands/batch-delete/
// -- /api/v1/poker/practice/sessions/batch-delete/

// /api/v2/poker/hand-history/batch-delete/
// /api/v2/poker/hand-history/files/batch-delete/

// --not on dev yet
// /api/v1/poker/custom-solutions/ranges/batch-delete/
// /api/v1/poker/custom-solutions/settings/batch-delete/

function getTrainerBase() {
  return {
    api_poker_shortcuts: { ...base() },
    api_poker_available_shortcuts: { ...base() },
    api_practice_setup: { ...base() },
    api_practice: { ...base() },
    api_practice_bot_action: { ...base() },
    api_practice_showdown: { ...base() },
    api_practice_action_tracking: { ...base() },
    // api_practice_quizz_tracking: { ...base() },
    api_poker_history: { ...base() },
    api_poker_next_actions: { ...base() },

    api_poker_custom_solution: { ...base() },
    api_poker_custom_solution_tree: { ...base() },
    api_poker_custom_solution_history: { ...base() },
    api_poker_tree_preview: { ...base() },
  }
}

const getInitialState = () => {
  const initialState = {
    api_uploads: [], // progress, finished, error, canceled

    [namespaces.STUDY]: {
      api_poker_history: { ...base() },
      api_poker_next_actions: { ...base() },
      api_poker_shortcuts: { ...base() },
      api_poker_available_shortcuts: { ...base() },
      api_poker_custom_solution: { ...base() },
      api_poker_custom_solution_tree: { ...base() },
      api_poker_custom_solution_history: { ...base() },
      api_poker_tree_preview: { ...base() },
    },
    [namespaces.REPORTS]: {
      api_poker_history: { ...base() },
      api_poker_next_actions: { ...base() },
      api_poker_shortcuts: { ...base() },
      api_poker_available_shortcuts: { ...base() },
      api_poker_custom_solution: { ...base() },
      api_poker_custom_solution_tree: { ...base() },
      api_poker_custom_solution_history: { ...base() },
      api_poker_tree_preview: { ...base() },
    },

    'tra/alpha': getTrainerBase(),
    'tra/beta': getTrainerBase(),
    'tra/gamma': getTrainerBase(),
    'tra/delta': getTrainerBase(),

    'tra/replay': getTrainerBase(),

    'tmp/primary': {
      api_poker_history: { ...base() },
      api_poker_next_actions: { ...base() },
      api_poker_shortcuts: { ...base() },
      api_poker_available_shortcuts: { ...base() },
      api_poker_custom_solution: { ...base() },
      api_poker_custom_solution_tree: { ...base() },
      api_poker_custom_solution_history: { ...base() },
      api_poker_tree_preview: { ...base() },
    },

    'tmp/secondary': {
      api_poker_history: { ...base() },
      api_poker_next_actions: { ...base() },
      api_poker_shortcuts: { ...base() },
      api_poker_available_shortcuts: { ...base() },
      api_poker_custom_solution: { ...base() },
      api_poker_custom_solution_tree: { ...base() },
      api_poker_custom_solution_history: { ...base() },
      api_poker_tree_preview: { ...base() },
    },
    'tmp/extra1': {
      api_poker_history: { ...base() },
      api_poker_next_actions: { ...base() },
      api_poker_shortcuts: { ...base() },
      api_poker_available_shortcuts: { ...base() },
      api_poker_custom_solution: { ...base() },
      api_poker_custom_solution_tree: { ...base() },
      api_poker_custom_solution_history: { ...base() },
      api_poker_tree_preview: { ...base() },
    },
    'tmp/extra2': {
      api_poker_history: { ...base() },
      api_poker_next_actions: { ...base() },
      api_poker_shortcuts: { ...base() },
      api_poker_available_shortcuts: { ...base() },
      api_poker_custom_solution: { ...base() },
      api_poker_custom_solution_tree: { ...base() },
      api_poker_custom_solution_history: { ...base() },
      api_poker_tree_preview: { ...base() },
    },
    'tmp/extra3': {
      api_poker_history: { ...base() },
      api_poker_next_actions: { ...base() },
      api_poker_shortcuts: { ...base() },
      api_poker_available_shortcuts: { ...base() },
      api_poker_custom_solution: { ...base() },
      api_poker_custom_solution_tree: { ...base() },
      api_poker_custom_solution_history: { ...base() },

      ...getTrainerBase(),
    },
  }
  const results = [
    'api_auth',
    'api_account_settings',
    'api_poker_solution',
    'api_poker_bubble_factors',
    'api_poker_next_actions',
    'api_poker_history',
    'api_poker_next_action',

    'api_poker_custom_solution',
    'api_poker_custom_solution_tree',
    'api_poker_custom_solution_history',

    'api_poker_custom_solutions_table', // v2 custom solution table

    'api_poker_custom_report_history',
    'api_custom_aggregated_report_table',

    'api_poker_tree_preview',

    'api_poker_player_ranges',

    'api_poker_custom_range',
    'api_poker_saved_ranges_table',

    // 'api_poker_custom_user_tree',
    'api_poker_custom_user_trees',
    'api_poker_saved_trees_table',

    'api_poker_custom_user_solution',
    'api_poker_saved_solutions_table',

    // api_poker_available_shortcuts
    'api_poker_shortcuts',
    'api_poker_shortcuts_flop',
    'api_poker_shortcuts_card',

    'api_poker_hand_history_hand_detail',
    'api_poker_files',

    // nextrls
    'api_v2_poker_hand_history_text',
    'api_v2_poker_files',
    'api_v2_poker_hh_hands',
    'api_v2_poker_hand_history_hands',
    'api_debug_shortcuts_table',

    'api_v2_hh_blinds',
    //--------

    'api_practice_sessions',
    'api_practice_session',

    'api_poker_practice_hands',
    'api_poker_practice_hand_detail',

    // 'api_practice',
    'api_practice_setup',
    // 'api_practice_bot_action',
    // 'api_practice_showdown',

    // 'api_account_practice_stats',
    'api_poker_reports',
    'api_custom_aggregated_report',
    'api_custom_aggregated_report_check',

    // 'payments_confirm_paypal',
    'api_payments_subscription_plan',
    'api_payments_subscription_paypal',
    'api_payments_subscription_stripe_customer',

    'api_poker_high_cards',
    'api_poker_suits',
    'api_poker_pairing',
    'api_poker_connectedness',
    'api_poker_board_type',

    'api_poker_drills',
    'api_poker_drill',

    'api_poker_drill_tags',
    'api_poker_saved_filters_tags',
    'api_poker_saved_spots_tags',
    'api_poker_saved_trees_tags',
    'api_poker_saved_ranges_tags',
    'api_poker_saved_solutions_tags',
    'api_poker_custom_solutions_tags',
    // 'api_poker_hhands_tags',
    // 'api_poker_drill_tag',
    // 'api_preferred_format_types',

    'api_poker_saved_spots_table',

    'api_poker_saved_filters',
    'api_poker_saved_filter',
    // 'api_poker_saved_filters_table', // for table only

    'api_coachings',

    // remove after survey
    'api_poker_custom_solution_table_initial_for_the_survey',
  ]
  results.forEach(key => {
    initialState[key] = { ...base() }
    // initialState.secondary[key] = { ...base() }
  })
  // debugger
  return initialState
}

const state = getInitialState()

const getters = {
  api_get: state => (key, namespace) => {
    if (namespace) {
      const r = state[namespace][key]
      return r
    }
    const r = state[key]
    return r
  },
  api_get_data: state => (key, namespace) => {
    if (namespace) {
      const r = state[namespace][key].response?.data
      return r
    }
    // if (!state[key]) {
    //   console.log(key)
    //   debugger
    // }
    const r = state[key].response?.data
    return r
  },
  api_get_status: state => (key, namespace) => {
    if (namespace) {
      const r = state[namespace][key]?.status
      return r
    }
    const r = state[key]?.status
    return r
  },
  api_get_error: state => (key, namespace) => {
    if (namespace) {
      const r = state[namespace][key]?.error
      return r
    }
    const r = state[key]?.error
    return r
  },
}

const mutations = {
  api_update(state, { namespace, key, result, mergeData, replace, ...mutationArgs }) {
    const s = namespace ? state[namespace] : state
    if (replace) {
      s[key] = result
      return
    }

    if (!s[key]) {
      console.warn(`${key} missing api_key`)
      return
    }

    if (mergeData) {
      const res = {
        ...s[key],
        ...result,
        response: {
          ...result.response,
          data: {
            ...result.response.data,
            results: [...s[key].response.data.results, ...result.response.data.results],
          },
        },
      }

      s[key] = res
      return
    }

    const res = {
      method: result.response?.config?.method,

      ...(mutationArgs || {}),
      ...result, // loading, loaded, method...

      error: result.response ? null : result.error?.response || result.error || s[key].error,
      response: result.error ? null : { data: (result.response || s[key].response)?.data || null },
      status: result.response
        ? result.response?.status
        : result.error
          ? result.error?.response?.status ||
            result.error?.request?.status ||
            result.error?.status ||
            0
          : s[key].status,
    }

    s[key] = res
  },
  api_update_data(state, { namespace, key, data }) {
    const s = namespace ? state[namespace] : state
    if (!s[key]) {
      console.warn(`${key} missing api_key`)
      return
    }
    let res = s[key]
    res = {
      ...res,
      // updated: Date.now(),
      response: {
        data,
      },
    }
    s[key] = res
  },
  api_reset(state, { namespace, key }) {
    const s = namespace ? state[namespace] : state
    s[key] = { ...base() }
  },
  api_uploads(state, data) {
    state.api_uploads = data
  },
}

export default {
  state,
  getters: {
    ...getters,
    ...clientGetters,
    ...solCallsGetters,
  },
  actions: {
    ...clientActions,
    ...historyCalls,
    ...solCallsActions,
    ...customSolutionCalls,
    ...practiceCalls,
    ...practiceTrainerCalls,
    ...uploadCalls,
    ...paymentsCalls,
    ...settingsCalls,
    ...shortcutsCalls,
    ...drillsCalls,
    ...tagsCalls,
    ...savedFilterCalls,
    ...coachingsCalls,
    ...gameformatsCalls,
  },
  mutations,
}
